import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import companyReducer from './slices/companySlice';
import moduleReducer from './slices/moduleSlice';
import productsReducer from './slices/productsSlice';
import customersReducer from './slices/customersSlice';
import { baseApi } from './api/baseApi';
// Import APIs to ensure endpoints are injected
import './api/authApi';
import './api/userApi';
import './api/roleApi';
import './api/companyApi';
import './api/inventoryApi';
import './api/salesApi';
import './api/purchaseApi';
import './api/dashboardApi';
import './api/saasApi';
import './api/backupApi';
import './api/rentalApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    module: moduleReducer,
    products: productsReducer,
    customers: customersReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});
